const PENDING_AUTH_REDIRECT_KEY = "pendingAuthRedirect";
const PENDING_PRODUCT_INTENT_KEY = "pendingProductIntent";

export const getReturnPath = (location) => {
  if (!location) {
    return "/";
  }

  return `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
};

export const savePendingAuthRedirect = (returnPath = "/") => {
  if (typeof localStorage === "undefined") {
    return;
  }

  localStorage.setItem(PENDING_AUTH_REDIRECT_KEY, returnPath || "/");
};

export const getPendingAuthRedirect = () => {
  if (typeof localStorage === "undefined") {
    return "";
  }

  return localStorage.getItem(PENDING_AUTH_REDIRECT_KEY) || "";
};

export const clearPendingAuthRedirect = () => {
  if (typeof localStorage === "undefined") {
    return;
  }

  localStorage.removeItem(PENDING_AUTH_REDIRECT_KEY);
};

export const savePendingProductIntent = (intent = {}) => {
  if (typeof localStorage === "undefined" || !intent.productId) {
    return;
  }

  localStorage.setItem(
    PENDING_PRODUCT_INTENT_KEY,
    JSON.stringify({
      productId: intent.productId,
      quantity: Math.max(1, Number(intent.quantity) || 1),
      selectedSize: String(intent.selectedSize || ""),
      selectedItems: Array.isArray(intent.selectedItems)
        ? intent.selectedItems
          .map((item) => ({
            selectedSize: String(item?.selectedSize || ""),
            quantity: Math.max(1, Number(item?.quantity) || 1),
          }))
          .filter((item) => item.selectedSize)
        : [],
      action: intent.action || "add_to_cart",
      returnPath: intent.returnPath || "/",
      savedAt: Date.now(),
    })
  );
};

export const consumePendingProductIntent = (productId) => {
  if (typeof localStorage === "undefined") {
    return null;
  }

  const rawIntent = localStorage.getItem(PENDING_PRODUCT_INTENT_KEY);

  if (!rawIntent) {
    return null;
  }

  try {
    const intent = JSON.parse(rawIntent);
    const isExpired = Date.now() - Number(intent.savedAt || 0) > 30 * 60 * 1000;
    const isSameProduct = String(intent.productId || "") === String(productId || "");

    if (isExpired || !isSameProduct) {
      localStorage.removeItem(PENDING_PRODUCT_INTENT_KEY);
      return null;
    }

    localStorage.removeItem(PENDING_PRODUCT_INTENT_KEY);
    return intent;
  } catch {
    localStorage.removeItem(PENDING_PRODUCT_INTENT_KEY);
    return null;
  }
};
